import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

interface DescriptionSectionsProps {
  sections: {
    executiveSummary?: string;
    keyInsights?: string;
    recommendations?: string;
    strategicTakeaways?: string;
    customerFeedback?: string;
  };
  onChange: (sections: DescriptionSectionsProps['sections']) => void;
}

export function DescriptionSections({ sections, onChange }: DescriptionSectionsProps) {
  const handleChange = (field: keyof DescriptionSectionsProps['sections'], value: string) => {
    onChange({
      ...sections,
      [field]: value,
    });
  };

  return (
    <Card style={{ boxShadow: '0 4px 6px -1px rgba(24, 61, 247, 0.3), 0 2px 4px -1px rgba(24, 61, 247, 0.18)' }}>
      <CardHeader>
        <CardTitle style={{ color: '#183df7' }}>Description Sections</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <Label htmlFor="executiveSummary">Executive Summary</Label>
          <Textarea
            id="executiveSummary"
            value={sections.executiveSummary || ''}
            onChange={(e) => handleChange('executiveSummary', e.target.value)}
            rows={4}
            placeholder="Provide an overview of the campaign performance and key highlights..."
            className="mt-2"
          />
        </div>

        <div>
          <Label htmlFor="keyInsights">Key Insights</Label>
          <Textarea
            id="keyInsights"
            value={sections.keyInsights || ''}
            onChange={(e) => handleChange('keyInsights', e.target.value)}
            rows={4}
            placeholder="Share important findings and observations from the campaign..."
            className="mt-2"
          />
        </div>

        <div>
          <Label htmlFor="recommendations">Recommendations</Label>
          <Textarea
            id="recommendations"
            value={sections.recommendations || ''}
            onChange={(e) => handleChange('recommendations', e.target.value)}
            rows={4}
            placeholder="Provide actionable recommendations based on the campaign results..."
            className="mt-2"
          />
        </div>

        <div>
          <Label htmlFor="strategicTakeaways">Strategic Takeaways</Label>
          <Textarea
            id="strategicTakeaways"
            value={sections.strategicTakeaways || ''}
            onChange={(e) => handleChange('strategicTakeaways', e.target.value)}
            rows={4}
            placeholder="Highlight strategic insights and learnings for future campaigns..."
            className="mt-2"
          />
        </div>

        <div>
          <Label htmlFor="customerFeedback">Customer Feedback Themes</Label>
          <Textarea
            id="customerFeedback"
            value={sections.customerFeedback || ''}
            onChange={(e) => handleChange('customerFeedback', e.target.value)}
            rows={4}
            placeholder="Summarize common customer feedback themes and comments..."
            className="mt-2"
          />
        </div>
      </CardContent>
    </Card>
  );
}
